import { Button, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useState } from 'react';

import { InvoiceListTable } from '../Tables/InvoiceListTable.component';
import { CreateSegmentInvoiceModal } from '../Modals/CreateSegmentInvoiceModal.component';
import { SEGMENT_INVOICE_TABLE_HEADERS } from '../../constants/invoice-table-headers.constant';
import { InvoiceTypes } from '../../types/invoice-type.type';

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  header: { display: 'flex', justifyContent: 'flex-end' },
  triggerButton: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

type Props = {
  segmentId: string;
};

export function SegmentInvoicesTab({ segmentId }: Props) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshSignal, setRefreshSignal] = useState(0);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Button
          className={classes.triggerButton}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => setModalOpen(true)}
        >
          Nouvelle facture
        </Button>
      </div>

      <InvoiceListTable
        headers={SEGMENT_INVOICE_TABLE_HEADERS}
        listParams={{ segmentId, type: InvoiceTypes.SEGMENT }}
        refreshSignal={refreshSignal}
      />

      <CreateSegmentInvoiceModal
        open={modalOpen}
        segmentId={segmentId}
        onClose={() => setModalOpen(false)}
        onCreated={() => setRefreshSignal((signal) => signal + 1)}
      />
    </div>
  );
}
